export default __webpack_public_path__ + "11b8689a19f3dd90d49a3e42b1c34f68.svg";